
import { 
  User,
} from "@models";

export class UserLoginClass {
  user: User | null = null; // This is the user that is used almost everywhere.
  true_user: User | null = null; // This is the user that is actually logged in. It's usually going to be the same, but we have both so that Admins can spoof other users.

  get spoofing() {
    return this.user && this.true_user && this.user._id !== this.true_user._id;
  }
}